module.exports = __webpack_public_path__ + "img/cargo-wagon-door-horizontal-top.dff462e3.png";